var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let SimpleHeader = class SimpleHeader extends LitElement {
    constructor() {
        super(...arguments);
        this.name = 'My Website';
        this.links = [
            { label: 'Home', href: '/' },
            { label: 'About', href: '/about' },
            { label: 'Contact', href: '/contact' },
        ];
    }
    render() {
        return html `
      <header class="ggo-simple-header">
        <div class="ggo-simple-header__left">
          <h1>${this.name}</h1>
        </div>
        <nav class="ggo-simple-header__right">
          <ul>
            ${this.links.map((link) => html `
                <li><a href="${link.href}">${link.label}</a></li>
              `)}
          </ul>
        </nav>
      </header>
    `;
    }
};
SimpleHeader.styles = css `
    .ggo-simple-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 11.25px 22.5px; /* Réduction de 25% */
      background-color: #f8f9fa; /* Couleur de fond claire */
      border-bottom: 2px solid #ddd; /* Ligne de séparation subtile */
      box-shadow: 0 1.5px 3px rgba(0, 0, 0, 0.1); /* Réduction de 25% */
    }

    .ggo-simple-header__left h1 {
      margin: 0;
      font-size: 1.35rem; /* Réduction de 25% */
      font-weight: 700;
      color: #333; /* Couleur sombre pour le titre */
      font-family: inherit;
    }

    a {
      text-decoration: none;
      color: inherit; /* Hérite de la couleur du parent */
      font-family: inherit;
    }

    .ggo-simple-header__right ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      gap: 15px; /* Réduction de 25% */
    }

    .ggo-simple-header__right li {
      margin: 0;
    }

    .ggo-simple-header__right a {
      text-decoration: none;
      color: #555ab9; /* Couleur cohérente avec les boutons primaires */
      font-weight: 600;
      font-size: 0.75rem; /* Réduction de 25% */
      transition: color 0.3s ease, transform 0.2s ease; /* Transition fluide */
    }

    .ggo-simple-header__right a:hover {
      color: #4a49a3; /* Couleur plus sombre au survol */
      transform: scale(1.05); /* Légère augmentation pour effet visuel */
    }

    .ggo-simple-header__right a:active {
      color: #3f3e8d; /* Couleur encore plus sombre au clic */
      transform: scale(0.95); /* Légère réduction pour effet de clic */
    }
  `;
__decorate([
    property({ type: String })
], SimpleHeader.prototype, "name", void 0);
__decorate([
    property({ type: Array })
], SimpleHeader.prototype, "links", void 0);
SimpleHeader = __decorate([
    customElement('simple-header')
], SimpleHeader);
export { SimpleHeader };
//# sourceMappingURL=SimpleHeader.js.map